import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../../shared/context/auth-context';
import { ContentCover } from '../components/ContentCover';
import { useFetchMasterclassQuery } from '../mediaApiSlice';
import { setMasterclass } from '../mediaSlice';

export function MasterclassCoverWrap() {
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const chid = window.location.pathname.split('/')[2];

  const masterclass = useSelector((state) => state.media.masterclass);

  const {
    data: media,
    isFetching,
    refetch,
  } = useFetchMasterclassQuery(
    {
      token: auth.token,
      chid,
    },
    {
      skip: !chid,
    }
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (!isFetching && media) {
      if (
        media.favourite !== masterclass.favourite ||
        masterclass.chid !== chid ||
        media.progress !== masterclass.progress ||
        media.like !== masterclass.like ||
        media.dislike !== masterclass.dislike ||
        media.title !== masterclass.title
      ) {
        dispatch(setMasterclass(media));
      }
    }
  }, [
    dispatch,
    media,
    isFetching,
    chid,
    masterclass.chid,
    masterclass.dislike,
    masterclass.favourite,
    masterclass.like,
    masterclass.progress,
    masterclass.title,
  ]);

  return (
    <div id="cover-page" className="masterclass-cover-page">
      {isFetching ? <LoadingSpinner asOverlay /> : <ContentCover mediaObject={masterclass} />}
    </div>
  );
}
